import type { ComponentPropsWithoutRef, ReactNode } from 'react'
import cn from 'classnames'
import useEmblaCarousel from 'embla-carousel-react'
import { useIntl } from '@/intl'
import {
  DotButton,
  useDotButton,
} from '@/scopes/checkout/components/services/CarRentalFilteringService/Carousel/CarouselDotButton'
import styles from './Carousel.module.css'

interface CarouselProps {
  children: ReactNode
}
type SlideProps = ComponentPropsWithoutRef<'div'>

export function Slide({ className, ...props }: SlideProps) {
  return (
    <div
      className={cn(styles.slide, className)}
      {...props}
    />
  )
}

export function Carousel({ children }: CarouselProps) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    dragFree: true,
  })
  const intl = useIntl()

  const { selectedIndex, scrollSnaps, onDotButtonClick }
    = useDotButton(emblaApi)
  return (
    <section className={styles.slider}>
      <div className={styles.viewport} ref={emblaRef}>
        <div className={styles.wrapper}>
          {children}
        </div>
      </div>
      <div className={styles.controls}>
        <div className={styles.dots}>
          {scrollSnaps.map((_, index) => {
            return (
              <DotButton
                key={index}
                onClick={() => onDotButtonClick(index)}
                selected={index === selectedIndex}
                aria-label={intl.formatMessage({ id: 'checkout_steps_ancillaries_car_rental_filtering_carousel_item' }, { item: index + 1 })}
              />
            )
          })}
        </div>
      </div>
    </section>
  )
}
